
import React from 'react';
import { Button } from "@/components/ui/button";

interface NoResultsProps {
  clearSearch: () => void;
}

const NoResults: React.FC<NoResultsProps> = ({ clearSearch }) => {
  return (
    <div className="container py-20 text-center">
      <h3 className="text-xl mb-2">No medications found</h3>
      <p className="text-muted-foreground">Try adjusting your search term</p>
      <Button 
        variant="outline" 
        className="mt-4" 
        onClick={clearSearch}
      >
        Clear search
      </Button>
    </div>
  );
};

export default NoResults;
